interface OutdatedBannerProps {
  appVersion: string | null;
  minAddonVersion: string;
}

export function OutdatedBanner({ appVersion, minAddonVersion }: OutdatedBannerProps) {
  if (!appVersion) return null;

  // Util: comparação simples de versões x.y.z.w
  function isVersionAtLeast(current: string, required: string): boolean {
    const a = (current || '').split('.').map((n) => parseInt(n, 10) || 0);
    const b = (required || '').split('.').map((n) => parseInt(n, 10) || 0);
    const len = Math.max(a.length, b.length);
    for (let i = 0; i < len; i++) {
      const ai = a[i] ?? 0;
      const bi = b[i] ?? 0;
      if (ai > bi) return true;
      if (ai < bi) return false;
    }
    return true;
  }

  const showBanner = !isVersionAtLeast(appVersion, minAddonVersion);
  
  if (!showBanner) return null;

  return (
    <div className="mb-3 text-[12px] bg-yellow-900/30 border border-yellow-700/50 text-yellow-300 rounded px-3 py-2">
      Add‑on desatualizado neste Docker. Versão instalada {appVersion}; mínimo recomendado {minAddonVersion}. Atualize o add‑on e reinicie o Corel.
    </div>
  );
}
